import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  autoAccept: string;
}

@Component({
  selector: 'app-dialog-auto-accept-copied-accruals',
  templateUrl: './dialog-auto-accept-copied-accruals.component.html',
  styleUrls: ['./dialog-auto-accept-copied-accruals.component.scss']
})
export class DialogAutoAcceptCopiedAccrualsComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogAutoAcceptCopiedAccrualsComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
  }

  CopyApproved() {
    this.data.autoAccept = 'approved';
    this.dialogRef.close(this.data);
  }
  CopyPending() {
    this.data.autoAccept = 'pending';
    this.dialogRef.close(this.data);
  }
  Cancel() {
    this.data.autoAccept = 'cancel';
    this.dialogRef.close();
  }
}